import { useNavigate, useLocation } from "react-router-dom";
import { useCallback } from "react";

export function useAppNavigation() {
  const navigate = useNavigate();
  const location = useLocation();

  const goTo = useCallback(
    (path: string, props?: Record<string, unknown>) => {
      navigate(path, { state: props });
    },
    [navigate]
  );

  const back = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  const replace = useCallback(
    (path: string, props?: Record<string, unknown>) => {
      navigate(path, { replace: true, state: props });
    },
    [navigate]
  );

  const getProps = useCallback(() => {
    return location.state as Record<string, unknown> | null;
  }, [location.state]);

  return {
    navigate: goTo,
    back,
    replace,
    getProps,
    currentPath: location.pathname,
  };
}
